.description-container {
    max-height: 200px;
    overflow-y: auto;
}
